
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import OsEntityToolbar from '@/components/core/OsEntityToolbar.vue';
import OsEntityForm from '@/components/core/OsEntityForm.vue';
import {
  AppuserState,
  IExtendedAppuser,
  IReportContentCategory,
  ReportContentCategoryState
} from '@/models/application';
import { EntityFormFieldType, IEntityFormField } from '@/models/core';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';

@Component({
  components: { OsSheetContent, OsEntityForm, OsEntityToolbar }
})
export default class OsReportContentCategoryForm extends Vue {
  @PropSync('appDirtyUtil', { required: true })
  internalAppDirtyUtil!: AppDirtyUtil;
  @Prop({ required: false, default: false })
  isCreateForm!: boolean;
  @PropSync('value', { required: true })
  internalValue!: IReportContentCategory;

  loading = false;
  formIsValid = false;

  get fields(): IEntityFormField[] {
    return [
      {
        type: EntityFormFieldType.radio,
        label: '',
        propName: 'state',
        smCols: 12,
        required: true,
        radioAsRow: true,
        readonly: this.isCreateForm,
        items: [
          { key: 'active', value: ReportContentCategoryState.Active },
          {
            key: 'inactive',
            value: ReportContentCategoryState.Inactive
          }
        ]
      },
      {
        type: EntityFormFieldType.text,
        label: 'Name',
        propName: 'name',
        smCols: 12,
        required: true
      }
    ];
  }

  get isDirty() {
    return AppDirtyUtil.isDirty;
  }

  onSave() {
    this.$emit('onSave');
  }

  onDelete() {
    this.$emit('onDelete');
  }

  onUndo() {
    this.$emit('undoClicked');
  }

  mounted() {
    this.internalAppDirtyUtil.init(this.internalValue);
  }

  @Watch('internalValue', { deep: true })
  onInternalValueChanged() {
    this.internalAppDirtyUtil.update(this.internalValue);
  }
}
